export const FETCH_LIST = 'FETCH_LIST';
export const CREATE = 'CREATE';
